export default __webpack_public_path__ + "static/media/Mask-1.17bc06df.jpg";